export default function TeamMember({team}) {
  return (
    <div className="checkbox-container">
      <img src={team.avatar} className="team-avater" alt={team.name} />
      <p className="label">{team.name}</p>
    </div>
  );
}
